import React from 'react';
import { PlaceholderBlock } from '../../styled/placeholders.styled';

export const StaticPlaceholder = () => (
  <div>
    <PlaceholderBlock width="193px" height="24px" margin="0 0 13px" />
    <PlaceholderBlock />
    <PlaceholderBlock />
    <PlaceholderBlock />
    <PlaceholderBlock />
    <PlaceholderBlock margin="0 0 25px" />
    <PlaceholderBlock />
    <PlaceholderBlock />
    <PlaceholderBlock />
    <PlaceholderBlock margin="0 0 20px" />
    <PlaceholderBlock />
    <PlaceholderBlock />
    <PlaceholderBlock />
    <PlaceholderBlock margin="0 0 25px" />
    <PlaceholderBlock margin="0 0 20px" />
    <PlaceholderBlock margin="0 0 30px" width="45%" />
  </div>
);
